import PublicAccount from './index';

export default { path: '/home/publicAccount', component: PublicAccount };
